import { Reveal } from "./Reveal";
import VoltageMeter from "./VoltageMeter";

export default function Scientific() {
  return (
    <section id="capitoli" className="relative py-24 sm:py-32 grid-lines">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-neon">
            Contenuto Scientifico — Cap. 01 / 02
          </p>
          <h2 className="mt-4 font-display font-bold tracking-tight text-white text-2xl sm:text-3xl lg:text-4xl max-w-3xl">
            L'ingegneria del sequestro: cosa succede al tuo corpo sotto comando
          </h2>
        </Reveal>
        <div className="mt-16 grid lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div className="space-y-8">
            <Reveal delay={0.1}>
              <article
                data-testid="scientific-chapter-1"
                className="bg-card border border-white/10 clip-card p-6 sm:p-8 hover:border-[rgba(255,85,0,0.4)] transition-colors"
              >
                <span className="font-display font-black text-5xl text-white/10">
                  01
                </span>
                <h3 className="mt-3 font-display font-semibold text-white text-xl sm:text-2xl">
                  IL SEQUESTRO BIOCHIMICO
                </h3>
                <p className="mt-4 text-sm sm:text-base leading-relaxed text-[#C4C4D0]">
                  L'asse HPA (Ipotalamo–Ipofisi–Surrene) è progettato per
                  emergenze di minuti, non per trimestri fiscali. Sotto stress
                  manageriale continuo il surrene non si spegne mai: il
                  cortisolo resta cronicamente elevato e il sistema nervoso
                  simpatico prende in ostaggio la corteccia prefrontale — la
                  sede della decisione strategica.
                </p>
                <p className="mt-4 text-sm sm:text-base leading-relaxed text-[#C4C4D0]">
                  Le onde Beta alte (20–30 Hz) diventano la firma elettrica
                  dominante: iper-vigilanza, loop ruminativi, perdita di
                  plasticità neuro-somatica. Il cervello smette di apprendere e
                  inizia a difendersi.
                </p>
              </article>
            </Reveal>
            <Reveal delay={0.2}>
              <article
                data-testid="scientific-chapter-2"
                className="bg-card border border-white/10 clip-card p-6 sm:p-8 hover:border-[rgba(255,85,0,0.4)] transition-colors"
              >
                <span className="font-display font-black text-5xl text-white/10">
                  02
                </span>
                <h3 className="mt-3 font-display font-semibold text-white text-xl sm:text-2xl">
                  IL CROLLO DEL VOLTAGGIO
                </h3>
                <p className="mt-4 text-sm sm:text-base leading-relaxed text-[#C4C4D0]">
                  Il cortisolo in eccesso attiva l'enzima IDO, che dirotta il
                  triptofano lontano dalla serotonina e lo converte in acido
                  chinolinico — un metabolita neurotossico che eccita i neuroni
                  fino all'esaurimento.
                </p>
                <p className="mt-4 text-sm sm:text-base leading-relaxed text-[#C4C4D0]">
                  Nel frattempo le citochine infiammatorie IL-6 e TNF-α — la
                  firma molecolare del "Genitore Critico" interno — collassano
                  il potenziale di membrana mitocondriale da −70mV fisiologici
                  a −40mV patologici. La cellula non produce più energia:
                  produce allarme.
                </p>
              </article>
            </Reveal>
          </div>
          <Reveal delay={0.3} className="lg:sticky lg:top-24">
            <VoltageMeter />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
